import { useEffect, useRef } from 'react'

const STEPS = [
  { num: 1, titleKey: 'step1_title', descKey: 'step1_desc', active: false },
  { num: 2, titleKey: 'step2_title', descKey: 'step2_desc', active: true },
  { num: 3, titleKey: 'step3_title', descKey: 'step3_desc', active: false },
  { num: 4, titleKey: 'step4_title', descKey: 'step4_desc', active: false },
]

function useFadeIn() {
  const ref = useRef(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('visible') },
      { threshold: 0.1 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])
  return ref
}

function StepItem({ step, t }) {
  const ref = useFadeIn()
  return (
    <div ref={ref} className={`step fade-in${step.active ? ' step-active' : ''}`}>
      <div className="step-num">{step.num}</div>
      <h3>{t[step.titleKey]}</h3>
      <p>{t[step.descKey]}</p>
    </div>
  )
}

export default function HowItWorks({ t }) {
  const headRef = useFadeIn()

  return (
    <section id="how">
      <div className="section-inner">
        <div ref={headRef} className="fade-in" style={{ textAlign: 'center' }}>
          <div className="section-tag" style={{ textAlign: 'center' }}>{t.how_tag}</div>
          <h2 style={{ textAlign: 'center' }}>
            {t.how_h2_1}<br /><em>{t.how_h2_em}</em>
          </h2>
          <p className="section-desc" style={{ margin: '0 auto', textAlign: 'center' }}>{t.how_desc}</p>
        </div>
        <div className="steps">
          {STEPS.map((step) => (
            <StepItem key={step.num} step={step} t={t} />
          ))}
        </div>
      </div>
    </section>
  )
}
